import TrackingLink from '../TrackingLink'

export const HalloweenRace = () => {
     return (<>
        <ul>
            <li>Princess Races este o secțiune dedicată turneelor organizate de Princess Casino sau de partenerii
                furnizori de jocuri.
            </li>
            <li>Promoţia este deschisă participării tuturor persoanelor fizice cu vârsta de peste 18 ani, cu capacitate
                deplină de exerciţiu și care au un cont activ și verificat pe website-ul PrincessCasino.ro.
            </li>
            <li>Închiderea/Suspendarea/Restricționarea contului din orice motive descalifică utilizatorul din promoție.
            </li>
            <li>Promoția are loc începând de miercuri, 27 octombrie, ora 00:00 până duminică, 31 octombrie ora 23:59.
            </li>
        </ul>
        <p><strong>Participare</strong></p>
        <ul>
            <li>Jocurile eligibile în cursă sunt: Starlight Princess, Gates of Olympus, Curse of the Werewolf Megaways,
                Madame Destiny Megaways, Wolf Gold, Voodoo Magic, Release the Kraken, Pirate Gold Deluxe, Wild Walker,
                The Magic Cauldron.
            </li>
            <li>Aduni puncte pe baza multiplicatorului fiecărei runde câștigate. De exemplu: dacă pariezi 2 RON și
                câștigi 5 RON, vei primi 2,5 puncte.
            </li>
            <li>Pariul minim pentru această cursă este de 2 RON.</li>
            <li>Punctajul unui jucător este suma tuturor multiplicatorilor obținuți la jocurile eligibile, din pariuri
                realizate cu bani cash în perioada desfășurării competiției.
            </li>
            <li>În cazul pariurilor realizate folosind funcția Cumpără Jocuri Gratuite, multiplicatorul se calculează
                împărțind valoarea câștigurilor rezultate din rotirile gratuite la valoarea totală plătită pentru
                obținerea respectivelor rotiri. De exemplu: dacă folosești 40 RON și câștigi 80 RON, vei primi 2 puncte.
            </li>
        </ul>
        <p><strong>Premii</strong></p>
        <span>Poți obține un premiu în două feluri:</span>
        <p><strong>Premii instant</strong></p>
        <ul>
            <li>În fiecare zi, sunt acordate câte 50 de premii de valori diferite. Premiile sunt acordate aleatoriu pe
                durata întregii zile, la fiecare 15 de minute, între 11:30 și 23:45.
            </li>
            <li>Pentru a fi eligibil pentru premiul instant un jucător trebuie să obțină minim 10 puncte în ziua
                respectivă (după ora 00.00 și până la ora 23:59 a zilei în curs).
            </li>
        </ul>
        <p><strong>Premii clasament</strong></p>
        <ul>
            <li>Adună cât mai multe puncte și califică-te în top 10 pentru unul dintre premiile puse la bătaie:</li>
        </ul>
        <div className="terms-table">
            <div className="terms-table-header">
                <div className="terms-table-row">
                    <div className="terms-table-data"><strong>Locul</strong></div>
                    <div className="terms-table-data"><strong>Premii</strong></div>
                </div>
                <div className="terms-table-row">
                    <div className="terms-table-data">1</div>
                    <div className="terms-table-data">5,000 RON CASH</div>
                </div>
                <div className="terms-table-row">
                    <div className="terms-table-data">2</div>
                    <div className="terms-table-data">3,000 RON CASH</div>
                </div>
                <div className="terms-table-row">
                    <div className="terms-table-data">3</div>
                    <div className="terms-table-data">2,000 RON CASH</div>
                </div>
                <div className="terms-table-row">
                    <div className="terms-table-data">4</div>
                    <div className="terms-table-data">1,500 RON CASH</div>
                </div>
                <div className="terms-table-row">
                    <div className="terms-table-data">5</div>
                    <div className="terms-table-data">750 RON CASH</div>
                </div>
                <div className="terms-table-row">
                    <div className="terms-table-data">6-10</div>
                    <div className="terms-table-data">500 RON CASH</div>
                </div>
                <div className="terms-table-row">
                    <div className="terms-table-data">11-15</div>
                    <div className="terms-table-data">250 RON CASH</div>
                </div>
                <div className="terms-table-row">
                    <div className="terms-table-data">16-20</div>
                    <div className="terms-table-data">100 RON CASH</div>
                </div>
                <div className="terms-table-row">
                    <div className="terms-table-data">21-30</div>
                    <div className="terms-table-data">75 RON CASH</div>
                </div>
                <div className="terms-table-row">
                    <div className="terms-table-data">31-50</div>
                    <div className="terms-table-data">50 RON CASH</div>
                </div>
            </div>
        </div>
        <p><strong>Termenii și condițiile competiției:</strong></p>
        <ul>
            <li>Promoția are loc începând de miercuri, miercuri, 27 octombrie, ora 00:00 până duminică, 31 octombrie ora
                23:59.
            </li>
            <li>Jocurile eligibile în cursă sunt: Starlight Princess, Gates of Olympus, Curse of the Werewolf Megaways,
                Madame Destiny Megaways, Wolf Gold, Voodoo Magic, Release the Kraken, Pirate Gold Deluxe, Wild Walker,
                The Magic Cauldron.
            </li>
            <li>Promoția se bazează pe un clasament, ce are drept criteriu de poziționare a jucătorilor suma punctelor
                adunate din pariurile plasate în jocurile participante.
            </li>
            <li>Cele mai bune scoruri sunt puse în partea de sus a clasamentului.</li>
            <li>Vor fi premiate primele 50 de locuri disponibile conform tabelului prezentat în descrierea promoției.
            </li>
            <li>În cazul în care este egalitate de puncte între doi jucători, suma totală rulată va fi folosită ca un
                criteriu de departajare. În situația în care este egalitate perfectă de puncte și de sumă totală rulată
                pe perioada promoției, premiul va fi împărțit între jucători.
            </li>
            <li>În cazuri de deconectare sau de probleme tehnice generale, toate rotirile afectate sunt anulate și
                excluse din promoție în scopuri de punctaj.
            </li>
            <li>Premiile care pot fi câștigate pot fi găsite în secțiunea Ce câștig? din descrierea promoției.</li>
            <li>Premiile vor fi acordate în balanță jucătorilor în următoarele 48 de ore de la încheierea competiției.
            </li>
            <li>Premiile vor fi acordate doar jucătorilor cu un cont activ. Utilizatorii care au solicitat închiderea
                contului de joc (indiferent de motiv) până la finalizarea competiției, nu vor fi eligibili pentru
                acordarea premiului.
            </li>
            <li>Oferta respectă <TrackingLink href="https://www.princesscasino.ro/terms-conditions">Termenii și Condițiile Princess
                Casino</TrackingLink>.
            </li>
            <li>Princess Casino își rezervă dreptul de a suspenda promoția pentru unul sau pentru toți jucătorii, fără
                explicații sau notificări prealabile, dacă promoția este folosită într-o manieră ce contravine Regulilor
                Organizatorului. În cazul unui litigiu cu un jucător, decizia Organizatorului va prevala.
            </li>
            <li>Princess Casino își rezervă dreptul de a exclude jucătorii care participă la promoții cu conturi
                multiple.
            </li>
            <li>Princess Casino își rezervă dreptul de a anula sau modifica termenii și condițiile acestei oferte fără
                notificare prealabilă.
            </li>
            <li>Pentru orice întrebări legate de prezenta promoție, utilizatorii sunt rugați să contacteze echipa de
                asistență la adresa de e-mail <a href="mailto:contact@princesscasino.ro">contact@princesscasino.ro</a>.
            </li>
        </ul>
    </>)
}